import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=13fffbac&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=13fffbac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fffbac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13fffbac')) {
      api.createRecord('13fffbac', component.options)
    } else {
      api.reload('13fffbac', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=13fffbac&scoped=true&", function () {
      api.rerender('13fffbac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8nBPJ0poyi4xR/JS/comp/SearchFilterTokens.vue"
export default component.exports